import React from "react";
import about1 from "../../assets/img/about-1.jpg";
import about2 from "../../assets/img/about.jpg";
import { Link } from "react-router-dom";
import "./About.css";

const About = () => {
  return (
    <section className="ftco-section ftco-about img">
      <div className="container">
        <div className="row d-flex">
          <div
            className="col-md-12 about-intro"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div className="row">
              <div className="col-md-6 d-flex">
                <div className="d-flex about-wrap">
                  <div
                    className="img d-flex align-items-center justify-content-center"
                    style={{ backgroundImage: `url(${about1})` }}
                  ></div>
                  <div
                    className="img-2 d-flex align-items-center justify-content-center"
                    style={{ backgroundImage: `url(${about2})` }}
                  ></div>
                </div>
              </div>

              <div className="col-md-6 pl-md-5 py-5">
                <div className="row justify-content-start pb-3">
                  <div className="col-md-12 heading-section ftco-animate">
                    <span className="subheading">Enhanced Your Skills</span>
                    <h2 className="mb-4">Learn Anything You Want Today</h2>
                    <p>
                      At Learnific, we believe education should be accessible,
                      engaging, and empowering. Whether you're starting a new
                      career, upgrading your skills, or exploring a passion —
                      our expert instructors and industry-aligned courses are
                      here to guide you every step of the way.
                    </p>
                    <p>
                      Join thousands of learners who trust us for professional
                      development in fields like technology, business, design,
                      marketing, and more.
                    </p>
                    <p>
                      <Link to="/contact" className="btn">
                        Get in touch with us
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
